module.exports = __webpack_public_path__ + "static/media/coins.6fd61163.jpg";